import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Form = () => {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Sign Up Successful!');
    navigate('/'); // Redirects to the home page
  };

  const handleLogin = () => {
    navigate('/login'); // Redirects to the login page
  };

  return (
    <StyledWrapper>
      <div className="container">
        <form className="form" onSubmit={handleSubmit}>
          <h2>Sign Up</h2>
          <div className="flex-column">
            <label>Name </label>
          </div>
          <div className="inputForm">
            <input type="text" className="input" placeholder="Enter your Name" required />
          </div>
          <div className="flex-column">
            <label>Email </label>
          </div>
          <div className="inputForm">
            <input type="email" className="input" placeholder="Enter your Email" required />
          </div>
          <div className="flex-column">
            <label>Password </label>
          </div>
          <div className="inputForm">
            <input type="password" className="input" placeholder="Enter your Password" required />
          </div>
          <button type="submit" className="button-submit">Sign Up</button>
          <p className="p">
            Already have an account? <span className="span" onClick={handleLogin}>Login</span>
          </p>
        </form>
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: #ffffff;
    padding: 30px;
    width: 400px;
    border-radius: 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .flex-column {
    text-align: left;
  }

  .inputForm {
    border: 1.5px solid #ecedec;
    border-radius: 10px;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    transition: 0.2s ease-in-out;
    background: white;
  }

  .input {
    margin-left: 10px;
    border: none;
    width: 100%;
    height: 100%;
    padding-left: 10px;
  }

  .input:focus {
    outline: none;
  }

  .inputForm:focus-within {
    border: 1.5px solid #2d79f3;
  }

  .button-submit {
    margin: 20px 0 10px 0;
    background-color: #151717;
    border: none;
    color: white;
    font-size: 15px;
    font-weight: 500;
    border-radius: 10px;
    height: 50px;
    width: 100%;
    cursor: pointer;
    transition: 0.3s;
  }

  .button-submit:hover {
    background-color: #252727;
  }

  .p {
    text-align: center;
    color: black;
    font-size: 14px;
    margin: 5px 0;
  }

  .span {
    color: #2d79f3;
    font-weight: 500;
    cursor: pointer;
    transition: 0.3s;
  }

  .span:hover {
    text-decoration: underline;
  }
`;

export default Form;
